import React, { useEffect, useRef, useState } from 'react'
import HeaderIcon from '../../../assets/images/header-icon/driver-info.png'
import DatePicker from '../../master/DatePicker'
import Input from '../../master/Input'
import SearchablePicker from '../../master/SearchablePicker'
import { pexios, toast, UserLabel, validate } from '../../../utils/functions'
import Modal from '../../master/Modal'
import { TimePicker } from '../../master/TimePicker'
import { useSelector } from 'react-redux'

function DriverInfo({data,changeData,changeStep}) {
    const {accidentInfo} = useSelector(store => store);
    const form = useRef(null);
    const [licenseTypes,setLicenseTypes] = useState([])
    const [LicenseLimitation,setLicenseLimitation] = useState([])
    const [loader,setLoader] = useState(false)
    useEffect(() => {
        setLoader(true)
        pexios('api/get_coding_data/license')
            .then(res => {
                setLicenseTypes(res.data);
                setLoader(false)
            });
    }, []);
    useEffect(() => {
        pexios('api/get_coding_data/licenselimit')
            .then(res => {
                setLicenseLimitation(res.data);
            });
    }, []);
    function submitInfo(){
        let error = ''
        if(form && form.current) error= validate(form);
        if (error) {
            toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            return;
        }
        changeStep('next')
    }
  return (
    <div>
        {loader ?
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
        :
        <>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <p className='guide-text mx10 mt10'>
        لطفا اطلاعات {accidentInfo.insurance_type === 'third' ? `${UserLabel(accidentInfo.user_type)} حادثه` :'زیر'} را جهت تسریع فرآیند بررسی و پرداخت خسارت خود تکمیل نمایید.
        </p>
        <div className='row text-right' ref={form}>
            <Input
                label='کد ملی راننده'
                value={data.driver_national_id}
                maxLength={10}
                mode='numeric'
                name='nationalId'
                onChange={value => changeData(value, 'driver_national_id')}
                required
            />
            <DatePicker
                label='تاریخ تولد راننده'
                isBirthDate
                value={data.driver_birth_date}
                onChange={date => changeData(date, 'driver_birth_date')}
                required
            />
            <Input
                label='شماره همراه راننده'
                value={data.driver_mobile}
                mode='numeric'
                type='tel'
                required
                onChange={value => changeData(value, 'driver_mobile')}
                maxLength={11}
            />
            {((accidentInfo.insurance_type === 'body')||(accidentInfo.insurance_type === 'third' && accidentInfo.user_type === 'losses')) &&
            <>
                <Input
                    label='کد ملی مالک خودرو'
                    value={data.owner_national_id}
                    maxLength={10}
                    mode='numeric'
                    name='nationalId'
                    onChange={value => changeData(value, 'owner_national_id')}
                    required
                />
                <DatePicker
                    label='تاریخ تولد مالک خودرو'
                    isBirthDate
                    value={data.owner_birth_date}
                    onChange={date => changeData(date, 'owner_birth_date')}
                    required
                />
            </>
            }
            {accidentInfo.user_type !== 'losses' &&
                <Input
                    label='شماره همراه مالک'
                    value={data.owner_mobile}
                    mode='numeric'
                    type='tel'
                    required
                    onChange={value => changeData(value, 'owner_mobile')}
                    maxLength={11}
                />
            }
            <SearchablePicker
                label='نوع گواهینامه'
                value={data.license_type_id}
                data={licenseTypes}
                titleKey='title'
                valueKey='id'
                required
                onSelect={val => changeData(val, 'license_type_id')}
                // fixed={true}
                rtl
            />
            {
                data.license_type_id !== 7 &&
                <Input
                    label='شماره گواهینامه'
                    value={data.license_number}
                    mode='numeric'
                    required
                    onChange={value => changeData(value, 'license_number')}
                />
            }
            <DatePicker
                label='تاریخ صدور گواهی نامه'
                value={data.license_start_date}
                required
                isLicenseDate
                onChange={date => changeData(date, 'license_start_date')}
            />
            {accidentInfo.user_type === 'culprit' &&
            <>
            <SearchablePicker
                label='محدودیت گواهی نامه'
                value={data.license_limitation_id}
                data={LicenseLimitation}
                titleKey='title'
                valueKey='id'
                rtl
                required
                onSelect={val => changeData(val, 'license_limitation_id')}
            />
            <DatePicker
                label='تاریخ حادثه'
                value={data.crash_time?.split(' ')[0]}
                onChange={date => {
                    // setAccidentTime(prev => ({...prev , date :date}))
                    changeData(`${date} ${data.crash_time?.split(' ')[1]||''}`, 'crash_time')
                }}
                required
            />
            <TimePicker
                label='ساعت حادثه'
                value={data.crash_time?.split(' ')[1]}
                onChange={time => {
                    // setAccidentTime(prev => ({...prev , time :time}))
                    changeData(`${data.crash_time?.split(' ')[0]||''} ${time}`, 'crash_time')
                }}
                required
            />
            </>
            }
            {((accidentInfo.insurance_type === 'body')||(accidentInfo.insurance_type === 'third' && accidentInfo.user_type === 'losses')) &&
            <Input
                label='شماره شبا مالک خودرو '
                value={data.owner_sheba_number}
                isLTR
                col={12}
                mode='numeric'
                onChange={value => changeData(value, 'owner_sheba_number')}
                hasIcon
                maxLength={24}
                name="sheba"
            >
                <i style={{top: '7px'}}>IR-</i>
            </Input>
            }
        </div>
        <div className='group-btn mt30'>
            <button className={`btn btn-circle btn-block btn-orange btn-bold`} onClick={()=>changeStep('prev')}>
                مرحله قبل
            </button>
            <button 
                className={`btn btn-circle btn-block btn-white-purple btn-bold`} 
                onClick={submitInfo}
                >مرحله بعد
            </button>
        </div>
        </>
    }
    </div>
  )
}

export default DriverInfo